const header = {
	state: {
        show:false,
        info:"BACK"
	},
	mutations: {
		showHeader (state,info) {
           
              state.show = true
              state.info = info?info:"BACK"
        },
        hideHeader (state) {
            state.show = false
        },

	}
}

export default header